import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f912fefc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f912fefc&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=f912fefc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f912fefc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f912fefc')) {
      api.createRecord('f912fefc', component.options)
    } else {
      api.reload('f912fefc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f912fefc&scoped=true", function () {
      api.rerender('f912fefc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/kanbanPlatform/vehicleDataMonitoring/index.vue"
export default component.exports